<nav class="vertical-nav">
  <ul class="nav">
    <li
      *ngFor="let tab of tabs"
      [ngClass]="{ 'arrow-nav-item': withArrow }"
      class="nav-item"
      (click)="onTabSelect(tab)"
    >
      <a
        [routerLink]="preventRouteChange ? [] : tab.url"
        [queryParams]="tab.queryParams"
        [replaceUrl]="true"
        routerLinkActive="active"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
        [ngClass]="{
          'justify-sm-center': isCentralisedForSmallScreen,
          'avoid-highlight-active': avoidActiveTabHighlight
        }"
        class="nav-link d-flex align-items-center"
      >
        <i
          *ngIf="tab.icon"
          [ngClass]="[tab.icon, isResponsive ? 'me-xxxl-2' : 'me-3']"
        ></i>
        <span
          class="nav-item-title"
          [ngClass]="{ 'd-none d-xxxl-block': isResponsive }"
          >{{
            isUppercaseTitle
              ? (tab.title | translate | uppercase | baseSoftHyphenate)
              : (tab.title | translate | baseSoftHyphenate)
          }}</span
        >
        <span
          *ngIf="tab.data?.badge as badge"
          class="nav-item-badge ms-auto"
          >{{ badge }}</span
        >
      </a>
    </li>
  </ul>
</nav>
